import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withKeys as _withKeys, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/ckb_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-4adcc461"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "abs-wrap flex-col flex-bwn flex-ter",
  id: "findpwd"
}
const _hoisted_2 = { class: "c-bar box-shadow flex-bwn" }
const _hoisted_3 = { class: "flex-ter" }
const _hoisted_4 = {
  key: 0,
  referrerPolicy: "no-referrer",
  class: "logo",
  style: {"height":"60px"},
  src: _imports_0,
  alt: "ホーム"
}
const _hoisted_5 = {
  key: 1,
  referrerPolicy: "no-referrer",
  class: "logo",
  style: {"height":"60px"},
  src: "https://static-s.theckb.com/BusinessMarket/icon/the ckb logo2.png",
  alt: "ホーム"
}
const _hoisted_6 = { class: "ft-w-6" }
const _hoisted_7 = { class: "link" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("| ")
const _hoisted_9 = { class: "section box-lg-shadow flex-col flex-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  style: {"display":"none"}
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  style: {"display":"none"}
}, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }

import { t } from '@/plugins/i18n'
import Footer from '@/views/layout/Footer.vue'
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getForgotCode, updatePasswordByEmail, UPBED, getMobileCode } from '@/apis/login'
import type { res } from '@/apis/login'
import { findPwd as createRules } from './rules'
import { useGetCode, useLoading } from './utils'
import { FormInstance, ElMessage as message } from 'element-plus'
import { BizType } from '@/common/const'
import { getCountryCodeList } from '@/common/utils'
import { useSite, isEN } from '@/store'

// 机器认证
type modeType = 'phone' | 'email'
/** 忘记密码模式 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showRecaptcha = ref(false)
const vueRecaptchaRef = ref()
// 获取人机校验接口
const recaptchaVerified = async (res: any) => {
  form.recaptchaCode = res
  const success = await getPhoneCode({ customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: BizType.RESET, countryPlaceCode: form.countryPlaceCode, recaptchaCode: res })
  success && step.value++
}
const recaptchaExpired = () => {
  vueRecaptchaRef.value.reset()
}

const router = useRouter()

const texts = ['注册邮箱', '邮箱验证码', '新密码设置', '再次确认新密码', '手机号', '手机号验证码', ' 新密码', '新密码（用于确认）'].map(t)
const tips = [
  '输入邮箱',
  '输入验证码',
  '设置你的登陆密码',
  '请再次输入您的密码',
  '请输入手机号',
  '请输入验证码',
  '请输入密码',
  '请输入密码（用于确认）'
].map(t)

const mode = ref<modeType>('phone')
/** 步骤 */
const step = ref(0)
/** 国家手机区域列表 */
const mobileAreaCodeOptions = ref<{ value: string; label: string }[]>([])
// /** 默认国家信息 */
// const defaultContry = ref()

const { disabled, getCode, getPhoneCode } = useGetCode('forgotCode', getForgotCode, getMobileCode)
/** formRef */
const formRef = ref<FormInstance>()

const [loading, api] = useLoading(updatePasswordByEmail)

/** 重置密码表单 */
const form = reactive<UPBED>({
  customerEmail: '',
  verificationCode: '',
  newPassword: '',
  repassword: '',
  countryCode: '',
  customerMobile: '',
  nationCode: '',
  countryPlaceCode: '',
  globalRoaming: '',
  recaptchaCode: '' // 谷歌人机密码code
})
/** 是否展示密码 */
const pwc = ref(true)
/** 表单提交规则 */
const rules = createRules(form, disabled)
/** 提交表单 */
const commit = async (e: Event) => {
  e.preventDefault()

  if (step.value === 0) {
    if (mode.value === 'email') {
      const success = await getCode(form.customerEmail)
      success && step.value++
    }
    if (mode.value === 'phone') {
      const checkResult = await formRef.value?.validateField([
        'customerMobile'
      ])
      form.globalRoaming = form.countryCode || ''
      if (checkResult) {
        const success = await getPhoneCode({ customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: BizType.RESET })
        success && step.value++
      }
    }
  } else {
    const f = formRef.value
    f?.validate((valid: any) => {
      console.log(valid)
      if (valid) {
        api(form).then((res: res) => {
          if (res.success) {
            message.success(t('密码修改成功'))
            router.push('/login')
          }
        })
      } else {
      }
    })
  }
}

/** 通过手机号找回密码 */
const changeBy = (type: modeType) => {
  mode.value = type
  step.value = 0
  formRef.value?.resetFields()
}
/** 获取区号列表 */
const getMobileArea = () => {
  // 区号列表
  const list = getCountryCodeList()
  mobileAreaCodeOptions.value = list.map(i => {
    return {
      label: i.mobileAreaCode,
      value: i.mobileAreaCode
    }
  }).concat({
    label: '—',
    value: ''
  })
  form.countryPlaceCode = list[0].key
  form.countryCode = list[0].mobileAreaCode
}

onMounted(() => {
  getMobileArea()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex-ter"
        }, {
          default: _withCtx(() => [
            (!_unref(isEN)())
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5))
          ]),
          _: 1
        }),
        _createElementVNode("i", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
          class: "btn fa fa-angle-left prefix"
        }),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('重设密码')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, { to: "/login" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('登录')), 1)
          ]),
          _: 1
        }),
        _hoisted_8,
        _createVNode(_component_router_link, { to: "/signup" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('注册')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (step.value === 1)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              formRef.value = _value
            },
            model: _unref(form),
            rules: _unref(rules),
            "label-width": `${_unref(isEN)() ? 180 : 140}px`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "verificationCode",
                label: mode.value === 'email' ? _unref(texts)[1] : _unref(texts)[5]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "number",
                    modelValue: _unref(form).verificationCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _unref(tips)[1]
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model", "rules", "label-width"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        model: _unref(form),
        rules: _unref(rules),
        "label-width": `${_unref(isEN)() ? 180 : 140}px`
      }, {
        default: _withCtx(() => [
          (step.value === 0 && mode.value === 'email')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_10,
                _createVNode(_component_el_form_item, {
                  prop: "customerEmail",
                  label: _unref(texts)[0]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _unref(form).customerEmail,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).customerEmail) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: _unref(tips)[0],
                      onKeyup: _withKeys(commit, ["enter"])
                    }, null, 8, ["modelValue", "placeholder", "onKeyup"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 64))
            : (step.value === 0 && mode.value === 'phone')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_11,
                  _createVNode(_component_el_form_item, {
                    prop: "customerMobile",
                    label: _unref(texts)[4]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        class: "customerMobile",
                        type: "phone",
                        modelValue: _unref(form).customerMobile,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).customerMobile) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _unref(tips)[4],
                        onKeyup: _withKeys(commit, ["enter"])
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(form).countryCode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).countryCode) = $event)),
                            style: {"width":"70px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileAreaCodeOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "onKeyup"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_el_form_item, {
                    prop: "newPassword",
                    label: _unref(texts)[2]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: pwc.value ? 'password' : 'input',
                        modelValue: _unref(form).newPassword,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).newPassword) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _unref(tips)[2]
                      }, null, 8, ["type", "modelValue", "placeholder"]),
                      _createElementVNode("i", {
                        class: _normalizeClass(["abs btn eye primary fa", pwc.value ? 'fa-eye-slash' : 'fa-eye']),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (pwc.value = !pwc.value))
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    prop: "repassword",
                    label: _unref(texts)[3]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: pwc.value ? 'password' : 'input',
                        modelValue: _unref(form).repassword,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).repassword) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _unref(tips)[3]
                      }, null, 8, ["type", "modelValue", "placeholder"]),
                      _createElementVNode("i", {
                        class: _normalizeClass(["abs btn eye primary fa", pwc.value ? 'fa-eye-slash' : 'fa-eye']),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (pwc.value = !pwc.value))
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
        ]),
        _: 1
      }, 8, ["model", "rules", "label-width"]),
      (mode.value === 'email')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_el_button, {
              round: "",
              class: "signin byPhone",
              loading: _unref(loading),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (changeBy('phone')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('使用手机号找回密码')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true),
      (mode.value === 'phone')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_el_button, {
              round: "",
              class: "signin byPhone",
              loading: _unref(loading),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (changeBy('email')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('使用邮箱找回密码')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          type: "primary",
          round: "",
          class: "signin",
          loading: _unref(loading),
          onClick: commit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})